module.exports = __webpack_public_path__ + "media/images/gallery/galaxies_on-e0bab81335088e5d7b87459803aac436.gif";